(function() {
'use strict';

let openLightboxCount = 0;

angular.module('TR')
    .directive('lightbox', lightbox);

function lightbox($timeout, broker) {
    return {
        restrict: 'E',
        replace: true,
        transclude: {
        // Modal title may be provided either by `headerText` attribute
        // or named transclusion i.e. `<modal-title> Details </modal-title>`
            title: '?modalTitle'
        },
        scope: {
            close: '&',
            include: '=',
            show: '=',
            busy: '=?',
            busyMsg: '@',
            innerClass: '@',
            headerText: '=',
            lightboxClass: '@',
            hideHeaderBar: '=',
            appendToBody: '@',
            preventClose: '=',
            renderEachLaunch: '=',
            additionalContent: '=',
            modalOverlayClass: '@',
            mandatoryTransfers: '='
        },
        template: '<div class="modal-overlay light-box-modal" ng-class="modalOverlayClass">' +
                    '<div class="lightbox" ng-class="lightboxClass">' +
                    '   <div class="lightbox-inner">' +
                    '       <div class="stage" ng-class="innerClass">' +
                    '           <div class="modal-header" ng-if="!hideHeaderBar">' +
                    '               <span class="modal-title" ng-transclude="title"></span> {{::headerText}}' +
                    '               <a ng-hide="preventClose" href="#" class="close" ng-click="closeClicked($event)"></a>' +
                    '           </div>' +
                    '           <div ng-show="busy" class="loader"><preloader class="circular subtle large"></preloader></div>' +
                    '           <div class="transclude modal-content" ng-transclude />' +
                    '           <div class="modal-content" onload="params = $parent && $parent.rc ? $parent.rc.modalParams : null" ng-include="include"></div>' +
                    '           <div class="modal-content-additional" ng-if="additionalContent" ng-bind-html="additionalContent"></div>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>' +
                  '</div>',

        link(scope, el, attr, ctrl, transclude) {
            const overlay = el;
            const domOverlay = overlay.get(0);
            const $body = $('body, html');
            const lightbox = el.find('.lightbox');
            const stage = el.find('.stage');
            let open = false;
            const transcludeElement = el.find('.transclude.modal-content');
            let previousScrollY = 0;

            scope.$watch('show', function(v) {
                /// When we open the lightbox for the first time after the page load, it will have to include the partial
                /// template content, which means loading it from the url. During that time "busy" will be set to true.
                /// Once the template is loaded it will change the "busy" value to false, and if we are showing the lightbox,
                /// a lightbox ready event will be published.
                if (!scope.busy && v) {
                    broker.publish('modal:ready');
                } else if (!v) {
                    broker.publish('modal:close');
                }

                if (v == null) {
                    return;
                }
                if (v) {
                    let cultureCode = TRPCONFIG.Domain.CultureCode;
                    cultureCode = cultureCode.split('-');

                    if (cultureCode[0] === 'ar') {
                        stage[0].classList.add('ar');
                    }

                    open = true;
                    openLightboxCount++;
                    if (scope.renderEachLaunch) {
                        transclude(function(clone) {
                            transcludeElement.html(clone);
                        });
                    }

                    //disable browser scroll bar
                    if (!previousScrollY) {
                        previousScrollY = window.scrollY;
                    }

                    if (scope.mandatoryTransfers !== 'enabled') {
                        $body.css({
                          marginTop: -previousScrollY,
                          overflow: 'hidden',
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0
                        });
                    }

                    if (scope.appendToBody) {
                        domOverlay._parent = overlay.parent();
                        $body.append(overlay);
                    }

                    overlay.fadeIn(300, 'swing', function() {
                        broker.publish('lightboxOpened');
                        $(window).resize(); //not particularly thrilled with this
                    });

                    // close if background is clicked
                    if (!scope.preventClose) {
                        lightbox.on('click.lightbox', function() {
                            scope.$apply(scope.close);
                            scope.show = false;
                        });
                        // support keyboard commands
                        $('html').on('keyup.lightbox', function(e) {
                            // escape to close
                            if (e.which === 27 && open) {
                                scope.$apply(scope.close);
                                scope.show = false;
                            }
                        });
                    }
                } else {
                    closeLightbox();
                }
            });

            function closeLightbox() {
                if (open) {
                    open = false;
                    openLightboxCount--;
                }

                overlay.fadeOut(200, 'swing', function() {
                    if (scope.appendToBody) {
                        $(domOverlay._parent).append(overlay);
                    }
                });

                // re-enable browser scroll bar
                if (!openLightboxCount) {
                  $body.css({
                    marginTop: '',
                    overflow: '',
                    position: '',
                    top: '',
                    left: '',
                    right: '',
                    bottom: ''
                  });
                  window.scrollTo(0, previousScrollY);
                }
            }

            scope.closeClicked = function(e) {
                e.preventDefault();
                broker.publish('lightboxCloseClicked');
                scope.close();
                scope.show = false;
            };

            stage.on('click.lightbox', function(e) {
                if (!$(e.target).hasClass('lightbox-propagate')) {
                    e.stopPropagation();
                }
            });

            scope.$on('$destroy', function() {
                closeLightbox();
                // unbind jquery event listeners
                $('html').off('keyup.lightbox');
                lightbox.off('click.lightbox');
                stage.off('click.lightbox');
            });

            if (scope.include) {
                scope.$on('$includeContentRequested', function() {
                    // we may be re-using a lightbox so ensure title is removed
                    el.find('.modal-title').empty();
                    scope.busy = true;
                });
            }

            scope.$on('$includeContentLoaded', function() {
                scope.busy = false;
                /// Loading of the partial for the modal is finished. Publish an event indicating that the lightbox
                /// content is loaded and that it's ready for any kind of operation.
                $timeout(function() {
                    if (scope.show) {
                        // Transclusion from within include file
                        el.find('modal-title').detach().last().appendTo(el.find('.modal-title'));
                        broker.publish('modal:ready');
                    }
                }, 0);
            });
        }
    };
}
})();
